import { connect } from 'react-redux';
import { allowPhoneNumberConfigSelector, isApplePhoneSelector, isForgotPasswordByEmailEnabled, isPhoneSelector } from '../../selectors/configSelectors';
import { isUploadInProgressSelector } from '../../selectors/uploadSelectors';
import LoginForm from './LoginForm';
import { hideModal, openModal } from '../../reducers/modalReducer';
import { hidePage } from '../../reducers/pageReducer';
import {
  isKioskMode as isKioskSelector,
} from '../../selectors/viewSelectors';
import { useKioskCustomer } from "../../actions/login";
import {
  isStartShoppingPopUp,
  isPaymentKiosk as isPaymentKioskSelector
} from '../../selectors/configSelectors';
import { beginIdScan, endIdScan, requestIdScan, cancelIdScan } from '../../reducers/paymentKioskReducer';
import { isHubConnected, isIdScanInError } from '../../selectors/paymentKioskSelectors';

const mapStateToProps = (state, ownProps) => ({
  isPhone: isPhoneSelector(state),
  isApplePhone: isApplePhoneSelector(state),
  isUploadInProgress: isUploadInProgressSelector(state),
  isKiosk: isKioskSelector(state),
  isPaymentKiosk: isPaymentKioskSelector(state),
  allowLoginPhoneNumber: allowPhoneNumberConfigSelector(state),
  showSignUp: !isPaymentKioskSelector(state),
  showShopping: isStartShoppingPopUp(state),
  formTitle: "WELCOME",
  showForgotPassword: true,
  showCloseIcon: ownProps.showCloseIcon,
  showSignInWithIdScan: isPaymentKioskSelector(state),
  showLoginInputs: !isPaymentKioskSelector(state),
  showIdScanError: isIdScanInError(state),
  isHubConnected: isHubConnected(state),
  isForgotPasswordByEmailEnabled: isForgotPasswordByEmailEnabled(state),
});

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...ownProps,
  ...stateProps,
  openResetPassword: () => {
    dispatch(hideModal());
    dispatch(hidePage());

    setTimeout(() => {
      dispatch(openModal({
        modalType: 'RESET_PASSWORD_FORM',
        modalProps: {}
      }));
    }, 100);
  },
  openReachOutUsResetPassword: () => {
    dispatch(hideModal());
    dispatch(hidePage());

    dispatch(openModal({
      modalType: 'REACH_OUT_US_RESET_PASSWORD',
      modalProps: {}
    }));
  },
  onShopping: () => {
    dispatch(useKioskCustomer());
    dispatch(hideModal());
    dispatch(hidePage());
  },
  onBeginSignInWithIdScan: () => {
    dispatch(beginIdScan());
    dispatch(requestIdScan());
  },
  onEndSignInWithIdScan: () => {
    dispatch(cancelIdScan());
    dispatch(endIdScan());
  }
});

export default connect(mapStateToProps, null, mergeProps)(LoginForm);



// WEBPACK FOOTER //
// ./src/components/LoginForm/LoginFormContainer.js